import React from "react";
import { Link } from "react-router-dom";

export default function ProgramsHeroSection({ data, className = "" }) {
  const ctas = (data.ctas || []).filter((cta) => cta.link);

  return (
    <section className={`programs-hero ${className}`.trim()}>
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-7">
            <div className="programs-hero-content text-center">
          <nav className="programs-hero-breadcrumbs" aria-label="Breadcrumb">
            <Link to="/">Home</Link>
            <span aria-hidden="true">|</span>
            <span>{data.breadcrumb}</span>
          </nav>

          <h1 className="heading">{data.title}</h1>
          {data.description && (
            <p className="programs-hero-description">{data.description}</p>
          )}

          {ctas.length > 0 && (
            <div className="programs-hero-actions">
              {ctas.map((cta) => (
                <Link
                  className={cta.className || "default-btn"}
                  to={cta.link}
                  key={`${cta.label}-${cta.link}`}
                >
                  {cta.label}
                </Link>
              ))}
            </div>
          )}

          {data.peopleImage && (
            <div className="programs-hero-trusted">
              {data.trustedLabel && <p>{data.trustedLabel}</p>}
              <img src={data.peopleImage} alt={data.peopleImageAlt || ""} />
            </div>
          )}
        </div>
          </div>
        </div>
      </div>
    </section>
  );
}
